import { ICaseFeedItem, ISupportCase, ISupportCaseDetail } from 'app/models/Candidate/SupportCases';

export { ICaseFeedItem, ISupportCase, ISupportCaseDetail };

export interface CasesState {
  cases: ISupportCase[];
  selectedCase: ISupportCaseDetail | null;
  loading: boolean;
  detailLoading: boolean;
  serviceFailure: boolean;
}

export const initialState: CasesState = {
  cases: [],
  selectedCase: null,
  loading: false,
  detailLoading: false,
  serviceFailure: false,
};
